var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconNotifications(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 34,
    height: 41,
    viewBox: "0 0 34 41",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    stroke: "transparent",
    d: "M19.266 7.002a.838.838 0 0 1-.838-.837V3.35c0-.923-.752-1.675-1.675-1.675s-1.675.752-1.675 1.675v2.815a.838.838 0 0 1-1.676 0V3.35A3.354 3.354 0 0 1 16.752 0a3.354 3.354 0 0 1 3.352 3.35v2.815a.837.837 0 0 1-.838.837z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "transparent",
    d: "M16.753 40.207a5.87 5.87 0 0 1-5.864-5.863.838.838 0 0 1 1.676 0 4.194 4.194 0 0 0 4.188 4.188 4.194 4.194 0 0 0 4.188-4.188.838.838 0 0 1 1.676 0 5.87 5.87 0 0 1-5.864 5.863z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "transparent",
    d: "M16.753 6.7c5.544 0 10.052 4.51 10.052 10.053v5.09a13.32 13.32 0 0 0 4.733 10.189.838.838 0 0 1-.545 1.474H2.513a.838.838 0 0 1-.538-1.48 13.31 13.31 0 0 0 4.726-10.184v-5.09c0-5.543 4.508-10.051 10.052-10.051zm14.24 28.481a2.515 2.515 0 0 0 2.513-2.513c0-.735-.32-1.43-.893-1.921a11.634 11.634 0 0 1-4.133-8.905v-5.09c0-6.466-5.26-11.726-11.727-11.726-6.467 0-11.727 5.26-11.727 11.727v5.09c0 3.437-1.506 6.684-4.147 8.915a2.51 2.51 0 0 0-.88 1.91 2.516 2.516 0 0 0 2.514 2.513z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconNotifications);
export default __webpack_public_path__ + "static/media/icon-notifications.835533e3ed5eaf81e6b43436a31dadab.svg";
export { ForwardRef as ReactComponent };